import React, { useEffect, useState, useContext } from "react";
import Controls from "../controls/controls";
import { GlobalContext } from "../../context/global.context";
import "./footer-bar.scss";

const FooterBar = () => {
  const { ragStatus, ragMessage } = useContext(GlobalContext);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setVisible(window.scrollY > 350);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  if (!visible) return null;

  return (
    <footer className="footer-bar">
      <a href="#home" className="footer-bar__home">
        home
      </a>
      <Controls
        className="footer-bar__controls"
        btnClassName="footer-bar__btn"
      />
      {ragStatus === "red_retry" && (
        <div className="footer-bar__rag-message">
          {ragMessage}
        </div>
      )}
    </footer>
  );
};

export default FooterBar;
